import { Box, Typography } from '@mui/material'
import FactoryIcon from '@mui/icons-material/Factory'


interface SiteCardProps {
  name: string
  onClick: () => void
}

const SiteCard = ({ name, onClick }: SiteCardProps) => {
  return (
    <Box
  onClick={onClick}
  sx={{
    minHeight: '200px',
    p: 3.25,
    border: '0.5px solid',
    borderColor: 'divider',
    borderRadius: 2,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
   
    '&:hover': { bgcolor: 'action.hover', borderColor: 'primary.main' },
  }}
>
       <FactoryIcon sx={{ fontSize: 40, mb: 1, color: 'text.secondary' }} />
      <Typography sx={{ fontSize: 20, fontWeight: 400, lineHeight: 1.4 }}>{name}</Typography>
    </Box>
  )
}

export default SiteCard